import { OrderCrudTab, type OrderCrudConfig } from '@/components/OrderCrudTab'

const RECEIVING_CONFIG: OrderCrudConfig = {
  entity: '입고전표',
  entityDate: '입고일자',
  entityNo: '입고번호',
  partnerLabel: '매입처',
  specColLabel: '규격',
  linesTitle: '입고 라인',
  searchPlaceholder: '입고번호, 매입처, 적요 검색',
  emptyText: '이 기간의 입고전표가 없습니다.',
  excelFilePrefix: '입고처리',

  apiBase: '/api/receiving',
  exportUrl: '/api/receiving/export',
  suggestUrl: '/api/receiving/suggest-price',
  queryKey: 'receivings',

  partnerBizClass: 'vendor',
  unitField: 'unit_in',
  totalColorClass: 'text-emerald-700',
  lineDateSplit: true,  // 선택 라인만 다른 입고일자로 분리
  excelImport: true,    // 엑셀(출고처리와 같은 더존 양식) 업로드로 전표 일괄 등록
}

export function ReceivingTab() {
  return <OrderCrudTab config={RECEIVING_CONFIG} />
}
